import * as React from "react";
import { useTranslation } from "react-i18next";
import { ContactsList } from "../../../components";
import CommonContainer from "../../../components/common/container/CommonContainer";

const ViewContacts: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <CommonContainer title={t("contactsListingPageTitle")} description={t("contactsListingPageDescription")}>
      <ContactsList />
    </CommonContainer>);
};

export default ViewContacts;
